import { render, staticRenderFns } from "./inProduction.vue?vue&type=template&id=81c3b6f4&"
import script from "./inProduction.vue?vue&type=script&lang=js&"
export * from "./inProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports